import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import { Link, useLocation, useParams } from "react-router-dom";
// import DyanamicRoutes from "routes/dynamicRoutes";
import "../../../assets/css/cms/Products.css";
import loadable from "@loadable/component";
import Loading from "../../utils/loader";
import { useSelector } from "react-redux";
import PermissionDenied from "../common/permissionDenied";
import { connect } from "react-redux";
import { CreateNewJobOpening } from "./createNewJobOpening";
import { EditJobOpening } from "./editJobOpening";
import { JOB_OPENING_PERMISSIONS } from "../../../constants/cms";

const FilterList = loadable(() => import("./filterList"), {
  fallback: () => <Loading />,
});

function JobOpeningHome(props) {
  const router = useLocation();
  const { params } = useParams();
  let relatedPath = router.pathname.split("/add-edit")[0];
  const [activeComponent, setActiveComponent] = useState();
  const { userPermission } = useSelector((state) => {
    return state.userData;
  });

  // Check if user has a specific permission or master permission
  const hasJobPermission = (action) => {
    const userPermissions = userPermission?.data;
    if (!userPermissions) return false;

    return userPermissions.some((permission) => {
      // Check for master permission (can_manage_job grants all actions)
      if (
        permission.content_type === JOB_OPENING_PERMISSIONS.content_type &&
        permission.name === JOB_OPENING_PERMISSIONS.can_manage
      ) {
        return true;
      }
      // Check for specific permission
      return (
        permission.content_type === JOB_OPENING_PERMISSIONS.content_type &&
        permission.name === action
      );
    });
  };

  // checking permission to show tabs (for backward compatibility)
  const findPermission = (application, action) => {
    let authorized = false;
    const userPermissions = userPermission?.data;
    if (userPermissions) {
      authorized = userPermissions.some((permission) => {
        // Check for master permission
        if (
          permission.content_type === JOB_OPENING_PERMISSIONS.content_type &&
          permission.name === JOB_OPENING_PERMISSIONS.can_manage
        ) {
          return true;
        }
        return (
          permission.content_type === application && permission.name === action
        );
      });
    }
    return authorized;
  };

  let ROUTES = [
    {
      path: "",
      index: true,
      element: <FilterList />,
      application: JOB_OPENING_PERMISSIONS.content_type,
      action: JOB_OPENING_PERMISSIONS.can_view,
    },
    {
      path: "create-new-job-opening",
      element: <CreateNewJobOpening />,
      application: JOB_OPENING_PERMISSIONS.content_type,
      action: JOB_OPENING_PERMISSIONS.can_edit,
    },
    {
      path: "edit-job-opening",
      element: <EditJobOpening />,
      application: JOB_OPENING_PERMISSIONS.content_type,
      action: JOB_OPENING_PERMISSIONS.can_edit,
    },
  ];

  useEffect(() => {
    if (params) {
      let activeComponent = ROUTES.find((obj) => {
        if (obj.path == params) {
          return obj;
        }
      });
      if (
        activeComponent &&
        activeComponent?.application &&
        activeComponent?.action &&
        !findPermission(activeComponent?.application, activeComponent?.action)
      ) {
        setActiveComponent(<PermissionDenied />);
      } else {
        setActiveComponent(activeComponent?.element);
      }
    } else {
      // Check permission for default route (listing)
      if (!hasJobPermission(JOB_OPENING_PERMISSIONS.can_view)) {
        setActiveComponent(<PermissionDenied />);
      } else {
        setActiveComponent(ROUTES[0].element);
      }
    }
  }, [params]);

  return (
    <div>
      <div className={"nav_container"}>
        <Nav className={"sub_nav"}>
          <Nav.Item
            className={`${
              relatedPath == "/cms/manage-job-opening" ||
              router.pathname == "/cms/manage-job-opening"
                ? "nav_links_active"
                : ""
            }`}
          >
            <Nav.Link>
              {" "}
              <Link to="/cms/manage-job-opening">Manage Job Openings</Link>
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
      {/* <DyanamicRoutes {...props} /> */}
      {activeComponent}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    _user_permission: state.userData?.userPermission,
  };
};

export default connect(mapStateToProps)(JobOpeningHome);
